export default {
    status: null,
    statusText: null,
    options: {},
};